import { FC, PropsWithChildren, createContext } from 'react'
import { FreeQrCodeGeneratorVariation1Document } from '@dtx-company/prismic-codegen'

export type LOCGPrismicContextType = {
  locgV2Data: FreeQrCodeGeneratorVariation1Document['data']
}

export const LOCGPrismicContext = createContext<LOCGPrismicContextType | undefined>(undefined)

export const LOCGPrismicProvider: FC<PropsWithChildren<LOCGPrismicContextType>> = props => {
  return <LOCGPrismicContext.Provider value={props}>{props.children}</LOCGPrismicContext.Provider>
}
